import { Header, HeaderTitle } from 'components/Header'
import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import classes from 'components/Form/Form.module.scss'
import classNames from 'classnames'
import ProjectConfiguration from 'modules/FormsContent/InfrastructureSelection/Fields/ProjectConfiguration'

interface InfrastructureSelectionProps {
  onCancel?: () => void
  onPrevious?: () => void
  showCancel?: boolean
  showPrevious?: boolean
  modalContent?: string
}
const InfrastructureSelection: FunctionComponent<
  InfrastructureSelectionProps
> = ({
  onCancel,
  onPrevious,
  showCancel = false,
  showPrevious = false,
  modalContent
}) => {
  const { t } = useTranslation()
  return (
    <>
      <Header
        onCancel={onCancel}
        showCancel={showCancel}
        onPrevious={onPrevious}
        showPrevious={showPrevious}
        modalContent={modalContent}
      >
        <HeaderTitle data-testid="infrastructure-type-title">
          {t('infrastructureSelection.title')}
        </HeaderTitle>
      </Header>
      <div
        className={classNames(
          classes.Form__InnerWrap,
          classes['Form__InnerWrap--space-top']
        )}
      >
        <ProjectConfiguration />
      </div>
    </>
  )
}

export default InfrastructureSelection
